




































import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { quillEditor } from "vue-quill-editor";
import { Quill, QuillOptionsStatic, RangeStatic, Sources, StringMap } from "quill";
import { History } from "../../../../forked-libs/quill/modules/history";
import Delta from "quill-delta/dist/Delta";
import { DomainRegistry } from "../../../../domain";
import { RichTextBoxItem } from "../../../../domain/document/items";
import { TextStyle, TextAlignKinds } from "../../../../domain/drawing";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { BrowserUtility, BrowserKinds } from "../../../../utilities";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { RichTextObjectStyleReader } from "../styleReaders";
import {
  StyledDrawableObjectMixin,
  FreeInputableMixin,
  ExternalTemplateInputtableMixin,
  ImeControllableMixin,
} from "./mixins";
import { IFreeInputableObject } from "./IFreeInputableObject";
import { RichTextBoxIeQuillBehaviorCorrector } from "./RichTextBoxIeQuillBehaviorCorrector";
import { RichTextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import { RichTextBoxInputMethodOptionKinds } from "../../../../domain/document/inputMethodOptionKinds";
import { FixedPhraseTextDropManager, IImageDragParameter, DocumentDataDropManager } from "../../../dragging";

// Quillはデフォルトでは指定されたフォントサイズ・フォントしか許容してくれない
// VueLoader.tsとmain.tsですべて許容するように指定している
// line-heightも許容する指定しないと消えてしまうので、指定できるように項目追加している（設定方法はまだ模索中）

@Component({
  components: {
    quillEditor,
  },
})
export default class RichTextBoxObject extends Mixins(
  StyledDrawableObjectMixin,
  FreeInputableMixin,
  ExternalTemplateInputtableMixin,
  ImeControllableMixin
) implements IFreeInputableObject {
  static uniqueId: number = 1;
  static readonly updateFontFamilyNamesEventType: string = "updateRichTextBoxObjectFontFamilyNames";
  static fontFamilyNames: string[] = null;
  static readonly quillCursorString: string = String.fromCharCode(0xFEFF);

  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new RichTextObjectStyleReader(configuration.style.document.editor.objects.richTextBox);
  }

  editingSource: RichTextBoxItem;

  data(): { editorOption: QuillOptionsStatic } {
    return {
      editorOption: {
        placeholder: "",  // これを指定しないと「Insert text here ...」が表示される
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ size: ["8px", "10px", "12px", "14px", "16px", "18px", "20px", "22px", "24px", "26px", "28px", "36px", "48px", "72px", "108px", "156px", "216px"] }],
            [{ script: "super" }, { script: "sub" }],  // 上付き・下付き
            [{ font: null }], // CSSで指定されていないフォントは使用できないため追加フォントには対応が難しいと思われる
            [{ color: ["#000000", "#808080", "#ff0000", "#ffafaf", "#ffc800", "#ffff00", "#00ff00", "#00b200", "#00ffff", "#0000ff", "#b200b2", "#ff00ff"] }],  // v1のカラーパレットを並べたが自由な変更は難しいと思われる
            // [{ background: [] as any[] }],
            [{ align: ["left", "center", "right"] }],      // justifyを非表示にしている
            [{ linespace: ["0", "2", "4", "6", "8", "10", "12", "14", "16", "18", "20"] }],
          ],
          keyboard: {
            bindings: {
              tab: {
                key: "tab",
                handler: () => true,  // タブキーでタブコードが挿入されないようにする対策(オブジェクト切り替え動作にする)
              },
            }
          }
        }
      }
    };
  }
  editorOption: QuillOptionsStatic;

  $refs!: {
    editor: quillEditor,
    drop: HTMLDivElement,
  };

  editorContent: string = "";
  uniqueId: number = 0;
  rootStyleElement: HTMLStyleElement = null;
  blockStyleElement: HTMLStyleElement = null;
  lastSelection: RangeStatic = null;
  lastSelectionAtFocusout: RangeStatic = null;
  ieQuillBehaviorCorrector: RichTextBoxIeQuillBehaviorCorrector = null;
  quill: Quill = null;
  quillHistory: History = null;
  isQuillReloading: boolean = false;
  compositionupdated: boolean = true;
  isDragStart: boolean = false;
  isDragging: boolean = false;
  isDroppable: boolean = false;
  dragOverTimer: NodeJS.Timeout = null;
  dropPanelGeneratedPosition: { x: number, y: number } = null;
  dragStartSelection: RangeStatic = null;
  isProcessingExternalTemplate: boolean = false;
  toolbarPosition: { top: number, left: number, draggingX: number, draggingY: number } = { top: 0, left: 0, draggingX: 0, draggingY: 0 };
  isInsertingByPasting: boolean = false;
  private isPointerDown: boolean = false;
  private heldAdjustedHeight: number = null;

  /**
   * 編集画面右側の「全てフリー入力」のチェックを入れたとき、テンプレートの入力内容とは異なった文字を入力可能
   * それが正解の動作なのか悩ましいところだが、V1で上記動作が可能なので挙動を合わせている
   */
  get isInputableText(): boolean {
    return this.isFreeInputable && this.shouldInputFreeSelfOrAll;
  }

  get shouldShowToolbar(): boolean {
    return this.isFocused && this.isInputableText;
  }

  get shouldShowQuillEditor(): boolean {
    return this.editorOption.modules.toolbar[3][0].font !== null && !this.isQuillReloading;
  }

  get isReadyQuill(): boolean {
    return !!this.quill;
  }

  get richTextAsHtml(): string {
    return this.readPropertyOrDefault<string>((s: RichTextBoxItem) => s.value, "<p><br></p>");
  }

  set richTextAsHtml(value: string) {
    this.writeProperty((s: RichTextBoxItem) => {
      if (this.isFreeInputable && this.isFreeInputOverwrittenByAll && this.isFocused && s.value !== value) {
        // 「全てフリー入力」の状態で手入力された場合はフリー入力に切り替える
        // ページ切り替えのタイミングでもQuill経由で値の更新が走るのでフォーカスの判定を入れてガードしている
        // また、「全てフリー入力」に切り替えた後にフォーカスを与えただけでも値の更新が走るのでvalueを比較している
        s.shouldInputFree = true;
      }
      s.value = value;
      if (this.isRelayoutableByHeight) {
        s.relayoutHeight = Math.max(this.originalHeight, this.measureRelayoutHeight());
      }
    });
  }

  get isEmpty(): boolean {
    return this.readPropertyOrDefault<boolean>((s: RichTextBoxItem) => s.isEmpty, true);
  }

  get textStyle(): TextStyle {
    return this.editingSource.textStyle;
  }

  get objectHeight(): number {
    return this.readPropertyOrDefault<number>((s: RichTextBoxItem) => s.geometry.rectangle.height, 0);
  }

  get originalHeight(): number {
    return this.readPropertyOrDefault<number>((s: RichTextBoxItem) => s.originalHeight, 0);
  }

  get adjustedHeight(): number {
    return this.readPropertyOrDefault<number>((s: RichTextBoxItem) => s.adjustedHeight, 0);
  }

  set adjustedHeight(value: number) {
    this.writeProperty((s: RichTextBoxItem) => {
      s.adjustedHeight = value;
      if (s.isRelayoutableByHeight) {
        s.geometry.rectangle.size.height = Math.max(s.adjustedHeight, s.originalHeight);
      }
    });
    this.$nextTick(() => {
      this.quillRootStyle();
    });
  }

  get relayoutHeight(): number {
    return this.readPropertyOrDefault<number>((s: RichTextBoxItem) => s.relayoutHeight, 0);
  }

  set relayoutHeight(value: number) {
    this.writeProperty((s: RichTextBoxItem) => {
      s.relayoutHeight = value;
    });
  }

  get rootClassName(): string[] {
    const classNames = [];
    if (!this.shouldShowToolbar) {
      // フォーカスが当たっていないときはツールバーを隠すための指定
      classNames.push("is-not-focused");
    }
    if (this.isRelayoutableByHeight) {
      // 高さ固定かどうかを制御するための指定
      classNames.push("is-relayoutable-by-height");
    }
    return classNames;
  }

  get isRelayoutableByHeight(): boolean {
    return this.editingSource.isRelayoutableByHeight;
  }

  get overrideStyleProperties(): any {
    return {
      zIndex: this.shouldDrawForeground ? "2" : "auto",  // 可変時にオブジェクトが重なった場合を考慮
      height: ((!this.isFocused || this.relayoutHeight === null) ? this.objectHeight : this.relayoutHeight) + "px"
    };
  }

  get maxTextLength(): number {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return configuration.behavior.document.editor.objects.richTextBox.maxTextLength;
  }

  get dropStyleProperties(): any {
    return {
      zIndex: !this.isDragging ? "-1" : undefined
    };
  }

  created(): void {
    this.setUniqueId();
    this.setEditorOptionToolbarFont();
    window.addEventListener("resize", this.onResize);
    window.addEventListener("pointerdown", this.onPointerDown, true);
    window.addEventListener("pointerup", this.onPointerUp);
    document.addEventListener("selectionchange", this.onSelectionChange);
    this.editorContent = this.richTextAsHtml;
  }

  private setUniqueId(): void {
    this.uniqueId = RichTextBoxObject.uniqueId;
    RichTextBoxObject.uniqueId++;
  }

  private setEditorOptionToolbarFont(): void {
    // 本来であれば await this.editorOption.modules.toolbar[3][0].font = this.getFontFamilyNames();
    // で問題ないが、IEの場合asyncにしたメソッドは無条件で遅延実行される模様でRepositoryのキャッシュ後でも描画に遅延が発生する
    // そのためここで別途キャッシュを用意し同期的に設定できるよう実装した
    if (RichTextBoxObject.fontFamilyNames === null) {
      const listener = () => {
        window.removeEventListener(RichTextBoxObject.updateFontFamilyNamesEventType, listener);
        this.editorOption.modules.toolbar[3][0].font = RichTextBoxObject.fontFamilyNames;
      };
      window.addEventListener(RichTextBoxObject.updateFontFamilyNamesEventType, listener);
      this.getFontFamilyNames().then(v => {
        RichTextBoxObject.fontFamilyNames = v;
        if (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer) {
          const event = document.createEvent("Event");
          event.initEvent(RichTextBoxObject.updateFontFamilyNamesEventType, false, false);
          window.dispatchEvent(event);
        } else {
          window.dispatchEvent(new Event(RichTextBoxObject.updateFontFamilyNamesEventType));
        }
      });
    } else {
      this.editorOption.modules.toolbar[3][0].font = RichTextBoxObject.fontFamilyNames;
    }
  }

  private async getFontFamilyNames(): Promise<string[]> {
    const repository = DomainRegistry.document.getDocumentRepository();
    const fontFamilyNames = await repository.getFontFamilyNames();
    return fontFamilyNames.map(v => this.toQuillFontFamily(v));
  }

  private onResize(): void {
    this.quillRootStyle();
  }

  destroy(): void {
    window.removeEventListener("resize", this.onResize);
    document.removeEventListener("selectionchange", this.onSelectionChange);
  }

  @Watch("isFocused")
  updateIsFocused(newValue: boolean, oldValue: boolean): void {
    if (newValue) {
      // ツールバーの状態が初回表示に反映しない対応のためフォーカスし直す
      // また、IEで入力を全削除してオブジェクトからフォーカスを外し、再度フォーカスを当て入力すると1文字目の追加位置が右に来てしまう問題もこれで対応できた
      this.refocus();
    }
    this.$nextTick(() => {
      this.quillRootStyle();
    });
  }

  @Watch("richTextAsHtml")
  updatedRichTextAsHtml(newValue: string, oldValue: string): void {
    // this.$logger.debug("updatedRichTextAsHtml");
    // 文字入力中にsetContents()が呼ばれないようactiveElementの状態を考慮する
    if ((!this.$el.contains(document.activeElement) ||  this.isProcessingExternalTemplate) && !!this.quill && newValue !== this.toRichTextAsHtml()) {
      try {
        const delta = this.quill.clipboard.convert(newValue as any);  // convertの引数は型定義と異なるため変換
        const selection = this.quill.getSelection();
        // dangerouslyPasteHTML()では選択状態を更新してしまいキャレットが残る場合があるためsetContents()で代用
        this.quill.setContents(delta);
        if (!!selection) {
          // 選択状態がコンテンツ範囲外を示す場合があるため補正する
          const length = delta.length();
          if (selection.index < 0) {
            selection.index = 0;
          } else if (selection.index >= length) {
            selection.index = length - 1;
          }
          this.quill.setSelection(selection.index, 0);
        }
        this.quillBlockStyle();
      } catch (e) {
        this.$logger.error("Quill error(updatedRichTextAsHtml)", e.message);
        this.quillReload();
      }
    }
    this.adjustedHeightValidation();
    this.$nextTick(() => {
      this.quillRootStyle();
    });
  }

  private async refocus(): Promise<void> {
    if (!this.quill) {
      return;
    }
    try {
      this.quill.blur();
      await this.$nextTick();
      if (!this.quill || !this.isFocused) {
        return;
      }
      this.quill.focus();
    } catch (e) {
      this.$logger.error("Quill error(refocus)", e.message);
      this.quillReload();
    }
  }

  private async quillReload(): Promise<void> {
    if (!!this.quill) {
      this.quill.off("text-change", this.quillTextChange);
      this.quill.off("selection-change", this.quillSelectionChange);
      this.quill.root.removeEventListener("copy", this.quillRootCopy, true);
      this.quill.root.removeEventListener("cut", this.quillRootCut, true);
      this.quill.root.removeEventListener("paste", this.quillRootPaste, true);
      this.quill.root.removeEventListener("compositionstart", this.quillRootCompositionstart);
      this.quill.root.removeEventListener("compositionend", this.quillRootCompositionend);
      this.quill = null;
    }
    this.quillHistory = null;
    if (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer) {
      this.ieQuillBehaviorCorrector.destroy();
      this.ieQuillBehaviorCorrector = null;
    }
    await this.$nextTick();
    this.isQuillReloading = true;
    await this.$nextTick();
    this.editorContent = this.richTextAsHtml;
    await this.$nextTick();
    this.isQuillReloading = false;
  }

  private adjustedHeightValidation(): void {
    if (this.isFocused && this.isRelayoutableByHeight && this.adjustedHeight === null) {
      this.$warn("警告", "可変する高さの上限に達しました。");
    }
  }

  onReady(quill: Quill): void {
    this.quill = quill;
    this.quillHistory = this.quill.getModule("history");
    this.quill.on("text-change", this.quillTextChange);
    this.quill.on("selection-change", this.quillSelectionChange);
    this.quill.root.addEventListener("copy", this.quillRootCopy, true);
    this.quill.root.addEventListener("cut", this.quillRootCut, true);
    this.quill.root.addEventListener("paste", this.quillRootPaste, true);
    this.quill.root.addEventListener("compositionstart", this.quillRootCompositionstart);
    this.quill.root.addEventListener("compositionend", this.quillRootCompositionend);
    this.quill.root.style.setProperty("ime-mode", this.imeModeStyleValue);  // 継承されないため直接付与
    this.quillHistory.clear();  // フォーマットで作成された文字列がアンドゥで消えてしまう対策
    // IEで範囲選択中に文字入力を行うとQuillの状態がおかしくなる問題の対応
    if (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer) {
      this.ieQuillBehaviorCorrector = new RichTextBoxIeQuillBehaviorCorrector(this.quill, this.quillReload, this.onTextChange);
    }
    this.quillToolbarEvent();
    this.quillBlockStyle();
    this.quillToolbarDefaultStyle();
    this.initializeDefaultFormat();
    this.$nextTick(() => {
      this.quillRootStyle();
    });
  }

  private initializeDefaultFormat(): void {
    // 初期値空の場合でもデフォルト属性が設定されるよう呼び出す（quillDefaultFormat()の代用）
    this.restoreScrollingAfterProcessing(this.$el as HTMLElement, async () => {
      await this.$nextTick();
      this.quill.focus();
      await this.$nextTick();
      this.quill.blur();
    });
  }

  private async restoreScrollingAfterProcessing(element: HTMLElement, action: () => Promise<void>): Promise<void> {
    const items: { scrollTop: number, scrollLeft: number }[] = [];
    this.processAncestorElement(element, (e) => {
      items.push({
        scrollTop: e.scrollTop,
        scrollLeft: e.scrollLeft
      });
    });
    await action();
    this.processAncestorElement(element, (e) => {
      const item = items.shift();
      e.scrollTop = item.scrollTop;
      e.scrollLeft = item.scrollLeft;
    });
  }

  private processAncestorElement(element: HTMLElement, action: (e: HTMLElement) => void): void {
    if (!element.parentElement) {
      return;
    }
    action(element);
    this.processAncestorElement(element.parentElement, action);
  }

  private holdAdjustedHeight(): void {
    // 下方向にある別オブジェクトをクリックしてフォーカスアウトさせた場合、可変した高さがオブジェクトの位置を変更させるため、見た目の位置でのクリックイベントが発生しなかった
    // そのため、フォーカスアウト時には高さの取得のみ行い、ポインタアップイベントにて高さの反映を行うことで対応した
    // また、ポインタによるフォーカスアウト時のみ問題があるため、それ以外は即時反映させる
    const adjustedHeight = this.editingSource.getAdjustedHeight();
    if (typeof adjustedHeight !== "number") {
      // 取得失敗するケースとして通信エラー、バックエンドで算出できない場合、可変する高さの上限に達した場合がある
      // 基本的にレアケースであり、別要因の問題となるため最低限のガードに留める
      this.$logger.warn("リッチテキストの高さ取得に失敗しました。");
      this.adjustedHeight = null;
      return;
    }
    if (this.isPointerDown) {
      this.heldAdjustedHeight = adjustedHeight;
    } else {
      this.adjustedHeight = adjustedHeight;
    }
  }

  private onPointerDown(e: PointerEvent): void {
    this.isPointerDown = true;
  }

  private onPointerUp(e: PointerEvent): void {
    this.isPointerDown = false;
    this.applyAdjustedHeight();
  }

  private applyAdjustedHeight(): void {
    if (typeof this.heldAdjustedHeight !== "number") {
      return;
    }
    this.adjustedHeight = this.heldAdjustedHeight;
    this.heldAdjustedHeight = null;
  }

  private quillTextChange(delta: Delta, oldContents: Delta, source: Sources): void {
    // this.$logger.debug("quillTextChange", JSON.stringify(delta), source, JSON.stringify(this.quill.getSelection()));
    if (source !== "user") {
      return;
    }
    if (!this.shouldUpdateRichTextAsHtml(delta)) {
      this.quillHistory.undo();
      return;
    }
    // IEはRichTextBoxIeQuillBehaviorCorrector経由でonTextChange()を呼び出すためここで抜ける
    if (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer) {
      return;
    }
    this.onTextChange();
  }

  private quillSelectionChange(range: RangeStatic, oldRange: RangeStatic, source: Sources): void {
    // this.$logger.debug("quillSelectionChange", range ? "[" + range.index + "," + range.length + "]" : range, oldRange ? "[" + oldRange.index + "," + oldRange.length + "]" : oldRange, source);
    if (!this.quill || !this.quill.hasFocus()) {
      return;
    }
    if (this.isFocused && !range) {
      // Quillのキャレットを跨ぐ選択(逆方向に選択)が行われた後に文字を入力すると選択状態が外れる場合があるため直前の選択状態に復元する
      this.quill.setSelection(oldRange);
      return;
    }
    this.quillDefaultFormat();
    this.updateRelayoutHeight();
  }

  private onSelectionChange(): void {
    const selection = window.getSelection();
    if (this.containsTargetNode(selection) && this.isUnexpectedSelectionPosition(selection)) {
      this.correctFirstSelectionPosition(selection);
    }
  }

  private containsTargetNode(selection: Selection): boolean {
    // 選択イベントはグローバルイベントのため対象どうか判定する
    if (!this.$refs || !this.$refs.editor) {
      return false;
    }
    return selection.anchorNode instanceof Node && this.$refs.editor.$el.contains(selection.anchorNode)
      && selection.focusNode instanceof Node && this.$refs.editor.$el.contains(selection.focusNode);
  }

  private isUnexpectedSelectionPosition(selection: Selection): boolean {
    // Quillの制御文字(0xFEFF)の左にDOMの選択位置がある場合、入力文字の反転が発生する
    // 未入力の状態からクリックでアクティブにし初期の装飾処理を行った際、発生する場合がある（デフォルトの装飾が中央揃えや右揃えでオブジェクトの左側をクリックした場合）
    return (selection.anchorOffset === 0 && selection.anchorNode.nodeValue === RichTextBoxObject.quillCursorString)
      || (selection.focusOffset === 0 && selection.focusNode.nodeValue === RichTextBoxObject.quillCursorString);
  }

  private correctFirstSelectionPosition(selection: Selection) {
    // Quillの制御文字の右側に選択位置が来るよう修正する
    const range = selection.getRangeAt(0);
    const clone = range.cloneRange();
    if (selection.anchorOffset === 0) {
      clone.setStart(selection.anchorNode, 1);
    }
    if (selection.focusOffset === 0) {
      clone.setStart(selection.focusNode, 1);
    }
    document.removeEventListener("selectionchange", this.onSelectionChange);
    selection.removeAllRanges();
    document.addEventListener("selectionchange", this.onSelectionChange);
    selection.addRange(clone);
  }

  private shouldUpdateRichTextAsHtml(delta: Delta): boolean {
    if (this.maxTextLength > 0 && this.quill.getLength() > this.maxTextLength) {
      this.$warn("警告", "入力文字数の上限に達しました。");
      return false;
    }
    // IME入力で文字入力とEnterを同時に押した場合、改行が複数入る場合がある問題が発生した
    // 発生後、Quillの状態不安定になってしまうため更新対象から外すように修正が必要になった
    // 基本的に改行が一度の通知で複数回上がることはなく、Enterが連打された場合でも複数回改行が通知されるのを有効とすべきであるためこのパターンを無効とした
    // 改行を含むペーストやドロップの場合は問題ないため条件に追加した
    if (!this.isInsertingByPasting && delta.ops.some(v => typeof v.insert === "string" && v.insert.startsWith("\n\n"))) {
      this.$logger.warn("QuillでIMEを使用したテキスト入力に問題がありました。");
      return false;
    }
    return true;
  }

  private onTextChange() {
    // this.$logger.debug("onTextChange");
    this.updateRichTextAsHtml();
    this.quillBlockStyle();
    this.isInsertingByPasting = false;
    this.$nextTick(() => {
      this.quillDefaultFormat();
    });
  }

  private updateRichTextAsHtml() {
    this.richTextAsHtml = this.toRichTextAsHtml();
  }

  private toRichTextAsHtml(): string {
    const clone = this.quill.root.cloneNode(true) as HTMLDivElement;
    // Quillの選択位置を示すDOMはバックエンドには不要なため取り除く
    const cursor = clone.getElementsByClassName("ql-cursor");
    if (cursor.length > 0) {
      const parent = cursor[0].parentNode;
      parent.removeChild(cursor[0]);
    }
    // 段落毎に確認
    Enumerable.from(clone.childNodes).forEach(e1 => {
      // Pタグ以外は削除
      if (e1.nodeName !== "P") {
        clone.removeChild(e1);
        return;
      }
      // 段落内を確認
      Enumerable.from(e1.childNodes).forEach(e2 => {
        // テキストが無いNodeは削除
        if (e2.textContent === "") {
          e1.removeChild(e2);
        }
      });
      // テキストが無い段落は改行に置き換え
      if (e1.textContent === "") {
        const p = e1.cloneNode(false);
        p.appendChild(document.createElement("br"));
        clone.replaceChild(p, e1);
      }
    });
    return clone.innerHTML;
  }

  private quillRootStyle(): void {
    // PDFとの差異を吸収するため間接的にCSSで高さを拡縮させる
    if (!this.quill) {
      return;
    }
    if (this.rootStyleElement !== null) {
      document.head.removeChild(this.rootStyleElement);
      this.rootStyleElement = null;
    }
    if (this.isFocused) {
      this.updateRelayoutHeight();
      return;
    }
    const clientHeight = this.measureRootFixedHeight();
    const scale = this.measureRootScale(clientHeight);
    if (scale === 0) {
      return;
    }
    const styleElement = document.createElement("style");
    styleElement.setAttribute("type", "text/css");
    styleElement.innerHTML = this.createRootStyleText(scale);
    this.rootStyleElement = styleElement;
    document.head.appendChild(this.rootStyleElement);
  }

  private measureRelayoutHeight(): number {
    let clientHeight = 0;
    const element = this.$refs.editor.$el.querySelector(".ql-editor");
    Enumerable.from(element.childNodes).forEach((e, i) => {
      clientHeight += (e as HTMLElement).getBoundingClientRect().height;
    });
    return clientHeight / this.scale;
  }

  private measureRootFixedHeight(): number {
    // 文字の高さに合わせた値を算出する
    // 保持しているrichTextAsHtmlとquill.root.innerHTMLが異なっている場合があるため保持している方から算出する
    let clientHeight = 0;
    this.editingSource.processTemporaryElement((element) => {
      Enumerable.from(element.childNodes).forEach((e, i) => {
        clientHeight += (e as HTMLElement).getBoundingClientRect().height;
      });
    });
    return clientHeight;
  }

  private measureRootScale(clientHeight: number): number {
    // 少ない行数での行の折り返しがPDFと異なる場合、文字がつぶれたように見えてしまう(ブラウザの拡大率を変更した場合発生しやすい)
    // 明らかにオブジェクトに収まるはずの文字サイズの場合、高さを拡縮させない
    if ((Math.max(clientHeight, this.adjustedHeight) <= this.originalHeight)) {
      return 0;
    }
    return (this.adjustedHeight !== 0 && clientHeight !== 0)
      ? this.adjustedHeight / clientHeight
      : 0;
  }

  private updateRelayoutHeight(): void {
    if (this.isRelayoutableByHeight) {
      this.relayoutHeight = Math.max(this.originalHeight, this.measureRelayoutHeight());
    }
  }

  private createRootStyleText(scale: number): string {
    return "\
    .rich-text-box-object-root[data-rich-text-box-object-id='" + this.uniqueId + "'] .ql-editor {\
      transform-origin: top left;\
      transform: scaleY(" + scale + ");\
      height: " + (100 / scale) + "%;\
    }\
    ";
  }

  private quillBlockStyle(): void {
    // 直接Pタグのstyleに適応するとPDFとの差異ができてしまうため間接的にCSSを適応し対応する
    if (this.blockStyleElement !== null) {
      document.head.removeChild(this.blockStyleElement);
      this.blockStyleElement = null;
    }
    let lastFont = {
      name: this.textStyle.fontFamily,
      size: this.textStyle.baseFontSize,
      height: this.editingSource.toFontHeight(this.textStyle.fontFamily, this.textStyle.baseFontSize)
    };
    let lastLineFontSize = 0;
    const styleElement = document.createElement("style");
    styleElement.setAttribute("type", "text/css");
    styleElement.innerHTML = Enumerable.from(this.quill.root.childNodes)
      .select(e => e as HTMLElement)
      .select((e, i) => {
        if (e.firstElementChild !== null && e.firstElementChild.tagName.toUpperCase() === "BR") {
          return this.createBlockStyleText(i + 1,  this.editingSource.createBrBlockLineHeightStyle(lastFont.height, lastLineFontSize));
        } else {
          const fontSize = this.editingSource.createBlockFont(e.childNodes, lastFont);
          lastFont = fontSize.last;
          const lineHeightValue = this.editingSource.toLineHeightValue(fontSize.max, e);
          lastLineFontSize = lineHeightValue.lineFontSize;
          const lineHeight = this.editingSource.createLineHeightStyle(lineHeightValue);
          return this.createBlockStyleText(i + 1, lineHeight);
        }
      })
      .toJoinedString();
    this.blockStyleElement = styleElement;
    document.head.appendChild(this.blockStyleElement);
  }

  private createBlockStyleText(index: number, lineHeight: string): string {
    return "\
    .rich-text-box-object-root[data-rich-text-box-object-id='" + this.uniqueId + "'] .ql-editor > p:nth-of-type(" + index + ") {\
      line-height: " + lineHeight + ";\
    }\
    ";
  }

  private quillRootCompositionstart(): void {
    this.compositionupdated = false;
  }

  private quillRootCompositionend(e: CompositionEvent): void {
    this.compositionupdated = true;
    if (e.data !== "") { // IME入力開始後最終的に未入力で確定した場合にも呼ばれるが、ここで書式を設定すると次のIME入力確定後にキャレット位置がおかしくなる.未入力の場合はガードする.
      this.quillDefaultFormat();
    }
  }

  private quillDefaultFormat(): void {
    // フォーカスが無い場合やIME使用中は何もしない
    if (!this.quill || !this.quill.hasFocus() || !this.compositionupdated) {
      return;
    }
    // 選択状態が取得できない場合は何もしない
    const selection = this.quill.getSelection();
    if (selection === null) {
      return;
    }
    // 選択位置の行頭にフォーマットが存在していれば対象外
    const line = this.quill.getLine(selection.index);
    const lineIndex = this.quill.getIndex(line[0]);
    const targetLength = selection.length === 0 // 範囲選択中は行頭のみを対象とするため1固定(0の場合選択範囲すべて変更対象になる)
      ? line[1]
      : 1;
    const lineFormat = this.quill.getFormat(lineIndex);
    const formatValue = this.toQuillNearbyFormatValue(lineIndex - 1);
    this.processQuillDefaultFormat(lineFormat, lineIndex, targetLength, formatValue);
    // 改行を範囲選択した状態で入力した場合フォーマットが存在しない文字が行頭以外に挟まれる場合があるため確認する
    if (selection.index - 1 > lineIndex) {
      const format = this.quill.getFormat(selection.index);
      this.processQuillDefaultFormat(format, selection.index - 1, 1);
    }
  }

  private toQuillNearbyFormatValue(index: number): StringMap {
    if (index < 0) {
      return this.toQuillDefaultFormatValue();
    }
    const format = this.quill.getFormat(index);
    return format.hasOwnProperty("font") && format.hasOwnProperty("size") && format.hasOwnProperty("color") && format.hasOwnProperty("align")
      ? format
      : this.toQuillNearbyFormatValue(index - 1);
  }

  private toQuillDefaultFormatValue(): StringMap {
    return {
      font: this.toQuillFontFamily(this.textStyle.fontFamily),
      size: this.textStyle.baseFontSize + "px",
      color: this.textStyle.color.value,
      align: this.toQuillTextAlign()
    };
  }

  private processQuillDefaultFormat(format: StringMap, index: number, length: number, value: StringMap = this.toQuillDefaultFormatValue()): void {
    if (!format.hasOwnProperty("font")) {
      this.runQuillFormat(index, length, "font", value.font, false);
    }
    if (!format.hasOwnProperty("size")) {
      this.runQuillFormat(index, length, "size", value.size, false);
    }
    if (!format.hasOwnProperty("color")) {
      this.runQuillFormat(index, length, "color", value.color, false);
    }
    if (!format.hasOwnProperty("align") && !!value.align) {
      this.runQuillFormat(index, length, "align", value.align, true);
    }
    // 行間(space-line)は-1しか入ってこない？(フォーマット編集でも設定項目が無さそう)ため、とりあえず非対応
  }

  private runQuillFormat(index: number, length: number, key: string, value: string, isLine: boolean): void {
    try {
      if (length > 0) {
        if (isLine) {
          this.quill.formatLine(index, length, key, value, "user");
        } else {
          this.quill.formatText(index, length, key, value, "user");
        }
      } else {
        this.quill.format(key, value, "user");
      }
    } catch (e) {
      this.$logger.error("Quill error(runQuillFormat)", e.message);
    }
  }

  private toQuillFontFamily(fontFamily: string): string {
    // Monospacedをmonospaceで扱うため変換
    return fontFamily.toLowerCase() === "monospaced" ? "monospace" : fontFamily;
  }

  private toQuillTextAlign(): string {
    switch (this.textStyle.textAlign) {
      case TextAlignKinds.TopLeft:
        return "left";
      case TextAlignKinds.TopCenter:
        return "center";
      case TextAlignKinds.TopRight:
        return "right";
      default:
        return null;
    }
  }

  private quillRootCopy(e: ClipboardEvent): void {
    e.preventDefault();
    const selection = this.quill.getSelection();
    if (!!selection && selection.length === 0) {
      return;
    }
    const data = this.quill.getText(selection.index, selection.length);
    const clipboardData = (e.clipboardData || (window as any).clipboardData) as DataTransfer;
    clipboardData.setData("text", data.replace(/\u00a0/g, " ").replace(/\n/g, "\r\n"));
  }

  private quillRootCut(e: ClipboardEvent): void {
    this.quillRootCopy(e);
    this.removeSelectedText();
  }

  private async quillRootPaste(e: ClipboardEvent): Promise<void> {
    e.preventDefault();
    const clipboardData = (e.clipboardData || (window as any).clipboardData) as DataTransfer;
    // 画像貼り付けを抑止するための対応
    if (clipboardData.files.length > 0) {
      return;
    }
    const clipboardText = clipboardData.getData("text");
    if (clipboardText === "") {
      return;
    }
    // IEでpasteText()内で行っているdeleteText()が呼ばれた際、削除が2度行われる現象が発生した
    // 改行が含まれる選択をしてペーストした場合発生した。右クリックメニューからは発生しないことから、ペーストイベント固有と判断
    // 遅延で実行したところ改善した
    // 逆に改行が含まれない範囲の場合削除されず追加される動きになったため、判定して動作を変える
    const range = this.quill.getSelection(true);
    if (this.quill.getContents(range.index, range.length).ops.length > 1) {
      await this.$nextTick();
    }
    this.pasteText(clipboardText);
  }

  private quillToolbarEvent(): void {
    const toolbar = this.$refs.editor.$el.getElementsByClassName("ql-toolbar")[0] as HTMLElement;
    toolbar.addEventListener("pointerdown", this.quillToolbarMouseDown);
    toolbar.addEventListener("click", this.quillToolbarClick);
  }

  private quillToolbarMouseDown(event: PointerEvent): void {
    // IEでテキストを選択した状態からフォントサイズやフォントを変更しようとした際、選択が外れてしまうため保持する
    this.lastSelection = this.quill.getSelection();
    this.quillToolbarDragStart(event);
  }

  private quillToolbarClick(): void {
    const selection = this.quill.getSelection();
    if ((selection === null || selection.length === 0) && this.lastSelection !== null && this.lastSelection.length !== 0) {
      // テキストの選択が外れていた場合、選択し直す
      this.quill.setSelection(this.lastSelection, "silent");
    }
  }

  private quillToolbarDefaultStyle(): void {
    const toolbar = this.$refs.editor.$el.getElementsByClassName("ql-toolbar")[0] as HTMLElement;
    if (!toolbar) {
      this.$nextTick(() => this.quillToolbarDefaultStyle());
      return;
    }
    const rect = toolbar.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) {
      // 動的に算出するとサイズが取得できない状態で呼び出される場合を考慮しリトライする
      this.$nextTick(() => this.quillToolbarDefaultStyle());
      return;
    }
    // オブジェクトの上が基本位置。上にスペースが無ければ下
    this.toolbarPosition.left = -3;
    this.toolbarPosition.top = this.absoluteGeometry.rectangle.y > rect.height
      ? -rect.height - 3
      : this.absoluteGeometry.rectangle.height + 3;
    this.quillToolbarStyle();
  }

  private quillToolbarDragStart(event: PointerEvent): void {
    document.addEventListener("pointermove", this.quillToolbarDraggingMouseMove);
    this.toolbarPosition.draggingX = event.clientX;
    this.toolbarPosition.draggingY = event.clientY;
  }

  private quillToolbarDraggingMouseMove(event: PointerEvent): void {
    if (event.buttons !== 1) {
      this.quillToolbarDragEnd();
      return;
    }
    // スケールを考慮し移動量を更新する
    this.toolbarPosition.left += (event.clientX - this.toolbarPosition.draggingX) / this.scale;
    this.toolbarPosition.top += (event.clientY - this.toolbarPosition.draggingY) / this.scale;
    this.toolbarPosition.draggingX = event.clientX;
    this.toolbarPosition.draggingY = event.clientY;
    this.quillToolbarStyle();
  }

  private quillToolbarDragEnd(): void {
    document.removeEventListener("pointermove", this.quillToolbarDraggingMouseMove);
    // 左や上にはみ出た場合は画面内に補正する。右や下はスクロールバーが表示されているはずなので何もしない
    if (this.toolbarPosition.left < -this.absoluteGeometry.rectangle.x) {
      this.toolbarPosition.left = -this.absoluteGeometry.rectangle.x;
    }
    if (this.toolbarPosition.top < -this.absoluteGeometry.rectangle.y) {
      this.toolbarPosition.top = -this.absoluteGeometry.rectangle.y;
    }
    this.quillToolbarStyle();
  }

  private quillToolbarStyle(): void {
    const toolbar = this.$refs.editor.$el.getElementsByClassName("ql-toolbar")[0] as HTMLElement;
    if (!toolbar) {
      return;
    }
    toolbar.setAttribute("style", "top: " + this.toolbarPosition.top + "px; left: " + this.toolbarPosition.left + "px;");
  }

  onMouseDown(): void {
    // マウス位置にキャレットが来るようにするため選択状態を初期化する
    this.lastSelectionAtFocusout = null;
    this.onFocus();
  }

  onFocus(): void {
    this.emitFocus();
    this.setFocusout();
    try {
      if (!this.quill) {
        return;
      }
      this.quill.focus();
    } catch (e) {
      // Quillの復帰を試みても復旧出来なかったためリロードする
      this.$logger.error("Quill error(onFocus)", e.message);
      this.quillReload();
    }
    this.setLastSelection();
  }

  private setFocusout(): void {
    if (!!this.$refs.editor) {
      this.$refs.editor.$el.removeEventListener("focusout", this.onFocusout);
    }
    // focusのタイミングで呼ばれると即focusoutが動作してしまうため
    this.$nextTick(() => {
      if (!this.$refs.editor) {
        return;
      }
      this.quillRootStyle();
      this.$refs.editor.$el.addEventListener("focusout", this.onFocusout);
    });
  }

  private onFocusout(event: FocusEvent): void {
    // オブジェクト内は対象外
    if (!this.quill || !this.$refs.editor || this.$refs.editor.$el.contains(event.relatedTarget as Node)) {
      return;
    }
    // IEのIME使用中は対象外
    const compositing = BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer && !!this.ieQuillBehaviorCorrector && this.ieQuillBehaviorCorrector.getCompositing();
    if (compositing) {
      return;
    }
    this.$refs.editor.$el.removeEventListener("focusout", this.onFocusout);
    // ブラウザ外をクリックした場合もfocusoutは発生するが、Quillの状態が変わらず以降の処理内でエラーが発生する。明示的に解除を入れる
    if (this.quill.hasFocus()) {
      this.quill.blur();
    }
    // ドラッグアンドドロップ中に入れ直した場合、状態不一致を発生させてしまうため呼び出さない
    if (!this.isDragStart && !this.isDragging) {
      // タブでオブジェクトを切り替える操作を行った場合、フォーカスが奪われ正しく動作しなかった。ここでは保持だけ行い、次回のフォーカス時に選択状態を復元する
      // 次回の選択状態を復元するために保持
      this.lastSelectionAtFocusout = this.quill.getSelection();
      // 入れ直しを行うと選択状態が失われるため、処理後復元させる
      this.restoreSelectionAfterProcessing(() => {
        // IMEで入力中に発生した場合を考慮し入れ直す
        this.quill.setContents(this.quill.clipboard.convert(this.richTextAsHtml as any), "silent"); // convertの引数は型定義と異なるため変換
      });
    }
    this.holdAdjustedHeight();
    this.quillBlockStyle();
    this.$nextTick(() => {
      this.quillRootStyle();
    });
  }

  private restoreSelectionAfterProcessing(process: () => void): void {
    const selection = window.getSelection();
    if (selection.rangeCount === 0) {
      process();
      return;
    }
    const range = selection.getRangeAt(0);
    if (range.collapsed) {
      process();
      return;
    }
    const startPoint = this.toElementPointFromNode(range.startContainer);
    const startOffset = range.startOffset;
    const endPoint = this.toElementPointFromNode(range.endContainer);
    const endOffset = range.endOffset;
    process();
    const startNode = this.toNodeFromPoint(startPoint.x, startPoint.y, startPoint.childIndex);
    const endNode = this.toNodeFromPoint(endPoint.x, endPoint.y, endPoint.childIndex);
    if (!startNode || !endNode) {
      return;
    }
    const newRange = document.createRange();
    newRange.setStart(startNode, startOffset);
    newRange.setEnd(endNode, endOffset);
    selection.removeAllRanges();
    selection.addRange(newRange);
  }

  private toElementPointFromNode(node: Node): { x: number, y: number, childIndex?: number } {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const rect = (node as Element).getClientRects().item(0);
      return {
        x: rect.left,
        y: rect.top
      };
    } else {
      let index = 0;
      let prev = node.previousSibling;
      while (!!prev) {
        index++;
        prev = node.previousSibling;
      }
      const rect = (node.parentNode as Element).getClientRects().item(0);
      return {
        x: rect.left,
        y: rect.top,
        childIndex: index
      };
    }
  }

  private toNodeFromPoint(x: number, y: number, childIndex?: number): Node {
    let node: Node;
    const findElement = (n: Node) => {
      if (n.nodeType !== Node.ELEMENT_NODE) {
        return;
      }
      const nodes = n.childNodes;
      const rects = (n as Element).getClientRects();
      for (let i = nodes.length - 1; i >= 0; i--) {
        findElement(nodes.item(i));
        if (!!node) {
          return;
        }
      }
      for (let i = 0; i < rects.length; i++) {
        const rect = rects.item(i);
        if (rect.bottom < y || rect.top > y || rect.right < x || rect.left > x) {
          continue;
        }
        node = n;
        break;
      }
    };
    findElement(this.$refs.editor.$el);
    if (!node) {
      return null;
    }
    return typeof childIndex === "number"
      ? node.childNodes[childIndex]
      : node;
  }

  private setLastSelection(): void {
    // 前回の選択状態があれば復元する
    if (!!this.quill && !!this.lastSelectionAtFocusout) {
      this.quill.setSelection(this.lastSelectionAtFocusout, "silent");
    }
    this.lastSelectionAtFocusout = null;
  }

  pasteText(value: string, isForcibly?: boolean): void {
    if (!this.quill.hasFocus()) {
      this.onFocus();
    }
    const insertValue = value.replace(/\r\n/g, "\n");
    const selection = this.quill.getSelection();
    if (!!selection && selection.length > 0) {
      this.quill.deleteText(selection.index, selection.length, "user");
    }
    const selectionIndex = !!selection
      ? selection.index
      : 0;
    const forwardText = selectionIndex > 0
      ? this.quill.getText(0, selectionIndex)
      : "";
    const insertText = (forwardText + insertValue)
      .replace(/\t/g, (s, i, t) => this.editingSource.replaceTabsWithSpaces(i, t))
      .slice(forwardText.length);
    const insertTextLength = insertText.length;
    const insertIndex = selectionIndex + insertTextLength;
    this.insertTextForPasting(selectionIndex, insertText, null, "user");
    const format = this.quill.getFormat(selectionIndex, insertText.length);
    this.processQuillDefaultFormat(format, selectionIndex, insertText.length);
    this.$nextTick(() => {
      this.quill.setSelection(insertIndex, 0, "user");
    });
  }

  private insertTextForPasting(index: number, text: string, formats?: StringMap, source?: Sources): Delta {
    this.isInsertingByPasting = true;
    return !!formats
      ? this.quill.insertText(index, text, formats, source)
      : this.quill.insertText(index, text, source);
  }

  getSelectedText(): string {
    const range = this.quill.getSelection();
    return (!!range && range.length > 0)
      ? this.quill.getText(range.index, range.length)
      : null;
  }

  overwriteText(value: string, isForcibly?: boolean): void {
    console.error("overwriteTextは実装されていません。");
  }

  removeSelectedText(): void {
    const selection = this.quill.getSelection();
    if (!selection || selection.length === 0) { return; }
    this.quill.deleteText(selection.index, selection.length, "user");
    // setSelectionしなくてもカーソル位置は問題なさそう
  }

  async onClick(): Promise<void> {
    if (!this.isInputableText) {
      // MKSテンプレート経由で2回目以降の値が@Watch("richTextAsHtml")経由で反映されないデグレがあったため、
      // 手動入力と判別させるためのフラグを復活させている（もともと実装があったのを#5483で削除していた）
      this.isProcessingExternalTemplate = true;
      try {
        await this.inputExternalTemplateWhenNeeded();
      } finally {
        await this.$nextTick(); // データ更新を反映させるためフラグ更新は遅延させる
        this.isProcessingExternalTemplate = false;
      }
    }
  }

  get inputMethodKind(): RichTextBoxInputMethodKinds {
    return this.editingSource.inputMethodKind;
  }

  set inputMethodKind(value: RichTextBoxInputMethodKinds) {
    this.writeProperty(s => {
      s.inputMethodKind = value;
      if (value !== RichTextBoxInputMethodKinds.MKSTemplate) {
        s.mksTemplateRegisteredId = null;
      }
      if (value !== RichTextBoxInputMethodKinds.DynamicTemplate) {
        s.dynamicTemplateRegisteredId = null;
      }
    });
  }

  get inputMethodOptionKind(): RichTextBoxInputMethodOptionKinds {
    return this.editingSource.inputMethodOptionKind;
  }

  @Watch("inputMethodKind")
  onInputMethodKindUpdated(newValue: RichTextBoxInputMethodKinds, oldValue: RichTextBoxInputMethodKinds): void {
    // TODO: implement
    if (newValue === RichTextBoxInputMethodKinds.MKSTemplate || newValue === RichTextBoxInputMethodKinds.DynamicTemplate) {
      this.$logger.warn("入力方法を外部テンプレートに切り替えた時に外部テンプレートを実行する機能は未実装です。");
    }
  }

  setFocus(): void {
    // ポップアップメニューからフリー入力に切り替えるとfocusが当たるが、そのまま色などを変更すると、
    // データ選択に戻ってしまうので対策している
    this.$nextTick(() => {
      this.onFocus();
    });
  }

  onDragStart(event: DragEvent): void {
    event.dataTransfer.effectAllowed = "copy";  // IEのブラウザ機能を使用した場合、copyをセットしておかないとmove動作になる模様
    this.isDragStart = true;
    this.dragStartSelection = this.quill.getSelection();  // 同一オブジェクト内にドロップする際、削除に必要なため保持
  }

  onDragEnd(event: DragEvent): void {
    this.isDragStart = false;
    this.dragStartSelection = null;
  }

  onDragOverFromRoot(event: DragEvent): void {
    event.stopPropagation();
    if (!this.isDragging) {
      this.isDragging = this.openDropElement();
      event.dataTransfer.dropEffect = "none";
      this.setDragOverTimer();
    }
  }

  onDragOverFromDropTarget(event: DragEvent): void {
    event.stopPropagation();
    if (!this.isDroppable) {
      this.isDroppable = this.confirmationOfPanelGeneration(event);
      event.dataTransfer.dropEffect = "none";
      this.setDragOverTimer();
      return;
    }
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
    this.setDragOverTimer();
  }

  private setDragOverTimer(): void {
    // イベント抜けを考慮しタイマでフラグをクリアする
    if (this.dragOverTimer !== null) {
      clearTimeout(this.dragOverTimer);
    }
    this.dragOverTimer = setTimeout(() => {
      this.closeDropElement();
    }, 2000);
  }

  private openDropElement(): boolean {
    if (!this.quill.root) {
      return false;
    }
    this.focus(null); // リッチのフォーカスが残ったまま別のリッチにドロップすると可変によるレイアウト崩れが発生する場合がある。事前にフォーカスを解除することにより回避
    if (!!this.$refs.drop.firstElementChild) {
      this.$refs.drop.removeChild(this.$refs.drop.firstElementChild);
    }
    const clone = this.quill.root.parentElement.cloneNode(true);  // レイアウトを揃えるため親をクローンする
    this.$refs.drop.appendChild(clone);
    return true;
  }

  private confirmationOfPanelGeneration(event: DragEvent): boolean {
    // IEではパネル生成後マウスを移動しないとドロップできないため無効とする。chromeではパネル生成が早く、影響が感じられないためブラウザの判定はしない
    if (this.dropPanelGeneratedPosition === null) {
      this.dropPanelGeneratedPosition = { x: event.clientX, y: event.clientY };
      return false;
    }
    return (this.dropPanelGeneratedPosition.x !== event.clientX || this.dropPanelGeneratedPosition.y !== event.clientY);
  }

  private closeDropElement(): void {
    if (this.dragOverTimer !== null) {
      clearTimeout(this.dragOverTimer);
    }
    this.isDragging = false;
    this.isDroppable = false;
    this.dropPanelGeneratedPosition = null;
  }

  onDragLeave(event: DragEvent): void {
    if (!this.quill.root || !this.isDragging || !this.$refs.drop.hasChildNodes()) {
      return;
    }
    const rect = this.$refs.drop.getBoundingClientRect();
    if (rect.left < event.clientX && event.clientX < rect.right && rect.top < event.clientY && event.clientY < rect.bottom) {
      return;
    }
    this.closeDropElement();
  }

  async onDrop(event: DragEvent): Promise<void> {
    // 定型文をドロップした場合、パラメータがクリアされないためここでクリアする
    const manager = new FixedPhraseTextDropManager();
    const droppedPhrase = manager.parameter; // AI定型文はここでハンドルするのでクリアする前に退避しておく.
    manager.parameter = null;

    // 過去データをドロップした場合、パラメータがクリアされないためここでクリアする
    DocumentDataDropManager.parameter = null;

    const droppedText = event.dataTransfer.getData("text");
    if (droppedPhrase && droppedPhrase.isAiPhrase) {
      await this.applyAiCreatedText(droppedText);
      return;
    }

    if (!this.quill || !this.$refs.drop.hasChildNodes()) {
      this.closeDropElement();
      return;
    }
    if (this.isDragDataImageRelatedJsonText(event.dataTransfer.getData("text"))) {
      this.closeDropElement();
      return;
    }
    if (this.dragOverTimer !== null) {
      clearTimeout(this.dragOverTimer);
    }

    const range = this.getRangeFromPoint(event);
    if (!!range) {
      // ブラウザの機能を止め、取得した選択位置にテキストを入れる
      range.insertNode(document.createTextNode(droppedText));
      event.preventDefault();
    }
    event.stopPropagation();
    try {
      if (!this.quill.hasFocus()) {
        this.onFocus();
      }
      const beforeDelta = this.quill.clipboard.convert(this.quill.root.innerHTML as any);
      // 同一オブジェクト内の文字の場合、選択範囲を削除する
      const deletedRange = !!this.dragStartSelection
        ? this.toFirstDeletedRange(this.quill.deleteText(this.dragStartSelection.index, this.dragStartSelection.length, "user"))
        : { index: 0, length: 0 };
      this.$nextTick(() => this.insertDropData(beforeDelta, deletedRange));
    } catch (e) {
      this.$logger.error("Quill error(onDrop)", e.message);
      this.quillReload();
      this.closeDropElement();
    }
  }

  private async applyAiCreatedText(source: string): Promise<string> {
    const result = await this.commonComponents.dialogs.aiPhrase.show({
      template: source,
      actions: {
        overwrite: true,
        insertToLast: true,
      },
    });
    if (!result.isConfirmed) { return; }

    const originalTextLength = this.quill.getLength() - 1;
    if (result.action === "overwrite") {
      this.quill.deleteText(0, originalTextLength, "user");
    }
    this.pasteAiText((result.action === "overwrite") ? 0 : originalTextLength, result.phrase);
  }

  pasteAiText(insertIndex: number, value: string): void {
    if (!this.quill.hasFocus()) {
      this.onFocus();
    }
    const insertValue = value.replace(/\r\n/g, "\n");
    const insertText = insertValue
      .replace(/\t/g, (s, i, t) => this.editingSource.replaceTabsWithSpaces(i, t));
    this.insertTextForPasting(insertIndex, insertText, this.toQuillDefaultFormatValue(), "user");
  }

  private isDragDataImageRelatedJsonText(json: string): boolean {
    try {
      if (!json) { return false; }
      const data = JSON.parse(json) as IImageDragParameter;
      return (data != null && (data.isClaioImage || data.isOcojoImage || data.isClaioSchema || data.isExternalImage || data.isRegisteredImage));
    } catch {
      return false; // jsonのパースに失敗しているのでIImageDragParameterではない
    }
  }

  private getRangeFromPoint(e: DragEvent): Range {
    if (!!document.caretRangeFromPoint) { // Chromium系にあるメソッドだが、非推奨のため今後サポートされなくなる可能性あり
      return document.caretRangeFromPoint(e.clientX, e.clientY);
    } else if (!!(e as any).rangeParent) {  // Firefoxにあるプロパティだが、規格にも存在しないため型定義が無い
      const r = document.createRange();
      r.setStart((e as any).rangeParent, (e as any).rangeOffset);
      return r;
    } else {  // IEはブラウザの機能で行うため返さない
      return null;
    }
  }

  private toFirstDeletedRange(src: Delta): RangeStatic {
    const opsLength = src.ops.length;
    let index = 0;
    for (let i = 0; i < opsLength; i++) {
      const o = src.ops[i];
      if (!!o.retain) {
        index = o.retain;
      }
      if (!!o.delete) {
        return { index, length: o.delete };
      }
    }
    return { index: 0, length: 0 };
  }

  private insertDropData(src: Delta, deletedRange: RangeStatic): void {
    try {
      if (this.quill.root && this.$refs.drop) {
        const dst = this.quill.clipboard.convert(this.$refs.drop.querySelector(".ql-editor").innerHTML as any);
        // 更新前のDOMからドロップしたDOMの変化量で文字を入力する
        // 同一オブジェクト内の文字の場合、選択範囲は削除済みのため、その範囲を考慮した位置に挿入させる
        this.insertDiffText(src, dst, deletedRange);
      }
    } catch (e) {
      this.$logger.error("Quill error(insertDropData)", e.message);
      this.quillReload();
    }
    this.closeDropElement();
  }

  private insertDiffText(src: Delta, dst: Delta, deletedRange: RangeStatic): void {
    if (!this.quill || !src || !dst) {
      return;
    }
    const diff = src.diff(dst);
    let textlength = this.quill.getLength();
    const opsLength = diff.ops.length;
    let retain = 0;
    for (let i = 0; i < opsLength; i++) {
      const o = diff.ops[i];
      if (!!o.retain) {
        // 削除範囲に応じて位置を補正する
        if (o.retain <= deletedRange.index) {
          retain += o.retain;
        } else if (o.retain <= deletedRange.index + deletedRange.length) {
          retain += deletedRange.index;
        } else {
          retain += o.retain - deletedRange.length;
        }
      }
      if (!!o.insert && typeof o.insert === "string") {
        if (textlength <= retain) {
          retain = textlength - 1;
        }
        this.insertTextForPasting(retain, o.insert, null, "user");
        const format = this.quill.getFormat(retain, o.insert.length);
        this.processQuillDefaultFormat(format, retain, o.insert.length);
        retain += o.insert.length;
        textlength += o.insert.length;
        this.quill.setSelection(retain, 0, "user");
      }
    }
  }
}
